import { remove, removeBulkMile } from '../index';

export const deleteMileStone = (data) => {
  return remove(`/statuses`, data);
};

export const deleteBulkMileStone = (data) => {
  return removeBulkMile(`/statuses/bulk`, data);
};
